// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnimatedNumberController from "./animated_number_controller"
application.register("animated-number", AnimatedNumberController)

import ChatScrollController from "./chat_scroll_controller"
application.register("chat-scroll", ChatScrollController)

import PaymentMethodController from "./payment_method_controller"
application.register("payment-method", PaymentMethodController)

import PlanChangePaymentController from "./plan_change_payment_controller"
application.register("plan-change-payment", PlanChangePaymentController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import FieldsArrayController from "./fields_array_controller"
application.register("fields-array", FieldsArrayController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import RailsBlocks__AccordionController from "./rails_blocks/accordion_controller"
application.register("accordion", RailsBlocks__AccordionController)

import RailsBlocks__AnimatedNumberController from "./rails_blocks/animated_number_controller"
application.register("rails-blocks--animated-number", RailsBlocks__AnimatedNumberController)

import RailsBlocks__AutocompleteController from "./rails_blocks/autocomplete_controller"
application.register("autocomplete", RailsBlocks__AutocompleteController)

import RailsBlocks__AutocompleteFuzzySearchController from "./rails_blocks/autocomplete_fuzzy_search_controller"
application.register("autocomplete-fuzzy-search", RailsBlocks__AutocompleteFuzzySearchController)

import RailsBlocks__AutocompleteNavigationController from "./rails_blocks/autocomplete_navigation_controller"
application.register("autocomplete-navigation", RailsBlocks__AutocompleteNavigationController)

import RailsBlocks__AutocompleteRecentSearchesController from "./rails_blocks/autocomplete_recent_searches_controller"
application.register("autocomplete-recent-searches", RailsBlocks__AutocompleteRecentSearchesController)

import RailsBlocks__AutogrowController from "./rails_blocks/autogrow_controller"
application.register("autogrow", RailsBlocks__AutogrowController)

import RailsBlocks__AutosubmitController from "./rails_blocks/autosubmit_controller"
application.register("autosubmit", RailsBlocks__AutosubmitController)

import RailsBlocks__BannerController from "./rails_blocks/banner_controller"
application.register("banner", RailsBlocks__BannerController)

import RailsBlocks__CarouselController from "./rails_blocks/carousel_controller"
application.register("carousel", RailsBlocks__CarouselController)

import RailsBlocks__CheckboxSelectAllController from "./rails_blocks/checkbox_select_all_controller"
application.register("checkbox-select-all", RailsBlocks__CheckboxSelectAllController)

import RailsBlocks__ClipboardController from "./rails_blocks/clipboard_controller"
application.register("clipboard", RailsBlocks__ClipboardController)

import RailsBlocks__CollapsibleController from "./rails_blocks/collapsible_controller"
application.register("collapsible", RailsBlocks__CollapsibleController)

import RailsBlocks__ConditionalFieldController from "./rails_blocks/conditional_field_controller"
application.register("conditional-field", RailsBlocks__ConditionalFieldController)

import RailsBlocks__ConfirmationController from "./rails_blocks/confirmation_controller"
application.register("confirmation", RailsBlocks__ConfirmationController)

import RailsBlocks__ContextMenuController from "./rails_blocks/context_menu_controller"
application.register("context-menu", RailsBlocks__ContextMenuController)

import RailsBlocks__DatatableController from "./rails_blocks/datatable_controller"
application.register("datatable", RailsBlocks__DatatableController)

import RailsBlocks__DatePickerController from "./rails_blocks/date_picker_controller"
application.register("date-picker", RailsBlocks__DatePickerController)

import RailsBlocks__DockController from "./rails_blocks/dock_controller"
application.register("dock", RailsBlocks__DockController)

import RailsBlocks__DrawerController from "./rails_blocks/drawer_controller"
application.register("drawer", RailsBlocks__DrawerController)

import RailsBlocks__DropdownPopoverController from "./rails_blocks/dropdown_popover_controller"
application.register("dropdown-popover", RailsBlocks__DropdownPopoverController)

import RailsBlocks__FeedbackController from "./rails_blocks/feedback_controller"
application.register("feedback", RailsBlocks__FeedbackController)

import RailsBlocks__HotkeyController from "./rails_blocks/hotkey_controller"
application.register("hotkey", RailsBlocks__HotkeyController)

import RailsBlocks__LightboxController from "./rails_blocks/lightbox_controller"
application.register("lightbox", RailsBlocks__LightboxController)

import RailsBlocks__MarqueeController from "./rails_blocks/marquee_controller"
application.register("marquee", RailsBlocks__MarqueeController)

import RailsBlocks__MenuController from "./rails_blocks/menu_controller"
application.register("menu", RailsBlocks__MenuController)

import RailsBlocks__ModalController from "./rails_blocks/modal_controller"
application.register("modal", RailsBlocks__ModalController)

import RailsBlocks__NavbarController from "./rails_blocks/navbar_controller"
application.register("navbar", RailsBlocks__NavbarController)

import RailsBlocks__OsDetectController from "./rails_blocks/os_detect_controller"
application.register("os-detect", RailsBlocks__OsDetectController)

import RailsBlocks__PasswordController from "./rails_blocks/password_controller"
application.register("password", RailsBlocks__PasswordController)

import RailsBlocks__PopoverController from "./rails_blocks/popover_controller"
application.register("popover", RailsBlocks__PopoverController)

import RailsBlocks__ScrollAreaController from "./rails_blocks/scroll_area_controller"
application.register("scroll-area", RailsBlocks__ScrollAreaController)

import RailsBlocks__SearchableDropdownController from "./rails_blocks/searchable_dropdown_controller"
application.register("searchable-dropdown", RailsBlocks__SearchableDropdownController)

import RailsBlocks__SelectController from "./rails_blocks/select_controller"
application.register("select", RailsBlocks__SelectController)

import RailsBlocks__SidebarController from "./rails_blocks/sidebar_controller"
application.register("rails-blocks--sidebar", RailsBlocks__SidebarController)

import RailsBlocks__SlideoverController from "./rails_blocks/slideover_controller"
application.register("slideover", RailsBlocks__SlideoverController)

import RailsBlocks__StepperController from "./rails_blocks/stepper_controller"
application.register("stepper", RailsBlocks__StepperController)

import RailsBlocks__TabsController from "./rails_blocks/tabs_controller"
application.register("tabs", RailsBlocks__TabsController)

import RailsBlocks__ToastController from "./rails_blocks/toast_controller"
application.register("toast", RailsBlocks__ToastController)

import RailsBlocks__TooltipController from "./rails_blocks/tooltip_controller"
application.register("tooltip", RailsBlocks__TooltipController)

import RailsBlocks__TreeViewController from "./rails_blocks/tree_view_controller"
application.register("tree-view", RailsBlocks__TreeViewController)

import RailsBlocks__TwoFactorController from "./rails_blocks/two_factor_controller"
application.register("two-factor", RailsBlocks__TwoFactorController)

import RecurringSchedule__PairController from "./recurring_schedule/pair_controller"
application.register("recurring-schedule--pair", RecurringSchedule__PairController)

import RecurringSchedule__RootController from "./recurring_schedule/root_controller"
application.register("recurring-schedule--root", RecurringSchedule__RootController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import RubyUi__AccordionController from "./ruby_ui/accordion_controller"
application.register("ruby-ui--accordion", RubyUi__AccordionController)

import RubyUi__AlertDialogController from "./ruby_ui/alert_dialog_controller"
application.register("ruby-ui--alert-dialog", RubyUi__AlertDialogController)

import RubyUi__CheckboxGroupController from "./ruby_ui/checkbox_group_controller"
application.register("ruby-ui--checkbox-group", RubyUi__CheckboxGroupController)

import RubyUi__ComboboxContentController from "./ruby_ui/combobox_content_controller"
application.register("ruby-ui--combobox-content", RubyUi__ComboboxContentController)

import RubyUi__ComboboxController from "./ruby_ui/combobox_controller"
application.register("ruby-ui--combobox", RubyUi__ComboboxController)

import RubyUi__ComboboxItemController from "./ruby_ui/combobox_item_controller"
application.register("ruby-ui--combobox-item", RubyUi__ComboboxItemController)

import RubyUi__DialogController from "./ruby_ui/dialog_controller"
application.register("ruby-ui--dialog", RubyUi__DialogController)

import RubyUi__DropdownMenuController from "./ruby_ui/dropdown_menu_controller"
application.register("ruby-ui--dropdown-menu", RubyUi__DropdownMenuController)

import RubyUi__FormFieldController from "./ruby_ui/form_field_controller"
application.register("ruby-ui--form-field", RubyUi__FormFieldController)

import RubyUi__SheetContentController from "./ruby_ui/sheet_content_controller"
application.register("ruby-ui--sheet-content", RubyUi__SheetContentController)

import RubyUi__SheetController from "./ruby_ui/sheet_controller"
application.register("ruby-ui--sheet", RubyUi__SheetController)

import RubyUi__SidebarController from "./ruby_ui/sidebar_controller"
application.register("ruby-ui--sidebar", RubyUi__SidebarController)

import RubyUi__TabsController from "./ruby_ui/tabs_controller"
application.register("ruby-ui--tabs", RubyUi__TabsController)

import RubyUi__TooltipController from "./ruby_ui/tooltip_controller"
application.register("ruby-ui--tooltip", RubyUi__TooltipController)

import SeatsController from "./seats_controller"
application.register("seats", SeatsController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SmallchatController from "./smallchat_controller"
application.register("smallchat", SmallchatController)

import RailsNestedForm from "@stimulus-components/rails-nested-form"
application.register("nested-form", RailsNestedForm)
